// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';


// import Swiper styles
import 'swiper/swiper-bundle.css';

const $ = window.jQuery;


const ProductGallery = {

    init() {

        // configure Swiper to use modules
        Swiper.use([Autoplay, Thumbs]);

        var $ProductGallery = $(document).find('#ProductGallery');

        if (!$ProductGallery.length)
            return;


        const ProductSwiper = new Swiper("#ProductGallery", {
            spaceBetween: 10,
            freeMode: false,
            allowTouchMove: false,
          autoHeight: true,
        });


        const $galleryNav = $('.gallery-nav');

        $galleryNav.on('click','li', function() {
            const index = $(this).data('index');

          ProductSwiper.slideTo(index, '700', function() {

          })
          $galleryNav.find('.active').removeClass('active')
            $(this).addClass('active');
        });


        Fancybox.bind("#ProductGallery .swiper-slide img", {
            dragToClose: false,

            Toolbar: false,
            closeButton: "top",

            Image: {
                zoom: false,
            },

            on: {
                initCarousel: (fancybox) => {
                    const slide = fancybox.Carousel.slides[fancybox.Carousel.page];

                    fancybox.$container.style.setProperty(
                        "--bg-image",
                        `url("${slide.$thumb.src}")`
                    );
                },
                "Carousel.change": (fancybox, carousel, to, from) => {
                    const slide = carousel.slides[to];

                    fancybox.$container.style.setProperty(
                        "--bg-image",
                        `url("${slide.$thumb.src}")`
                    );
                },
            },
        });


    
    },

};

export default ProductGallery;
